export const trailerDefaultValues = {
	van: {
		1: {
			amount: 2.0,
			month: "AUG",
		},
		2: {
			amount: 2.22,
			month: "SEP",
		},
		3: {
			amount: 2.56,
			month: "OCT",
		},
		4: {
			amount: 2.32,
			month: "NOV",
		},
	},
	flatbed: {
		1: {
			amount: 2.0,
			month: "AUG",
		},
		2: {
			amount: 2.22,
			month: "SEP",
		},
		3: {
			amount: 2.56,
			month: "OCT",
		},
		4: {
			amount: 2.32,
			month: "NOV",
		},
	},
	reefer: {
		1: {
			amount: 2.0,
			month: "AUG",
		},
		2: {
			amount: 2.22,
			month: "SEP",
		},
		3: {
			amount: 2.56,
			month: "OCT",
		},
		4: {
			amount: 2.32,
			month: "NOV",
		},
	},
};
